<template>
  <div class="document-overage display">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <p class="title md-headline">Document overages
          <span class="md-subheading ">
            <md-icon class="md-size-xs">info</md-icon>
            <md-tooltip>{{ $t('tooltips.enterprise.documentOverages') }}</md-tooltip>
          </span>
        </p>
      </div>
    </div>
    <div v-if="!localEnterprise.billingCustomer.id">
      <div class="md-layout md-gutter mb-1">
        <div class="md-layout-item md-small-size-100">
          <p class="md-subheading">
            Please configure Stripe Customer ID to edit overage information.
          </p>
        </div>
      </div>
    </div>
    <div v-if="localEnterprise.billingCustomer.id">
      <div class="md-layout md-gutter mb-1" v-if="!updatingOverage">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Price per overage document</p>
          <span class="md-subheading" v-if="localEnterprise.owner.stripeOveragePrice">
            {{ localEnterprise.owner.stripeOveragePrice | toCurrency }}
          </span>
          <span class="md-subheading" v-if="!localEnterprise.owner.stripeOveragePrice">
            Not set.
          </span>
        </div>
      </div>

      <form
        class="md-layout md-gutter"
        v-if="updatingOverage"
        @submit.prevent="setPrice">
        <div class="md-layout-item md-small-size-100">
          <md-field name="newPrice">
            <label for="newPrice">
              Price (format: 0.00)
            </label>
            <md-input v-model="overage.newPrice" name="newPrice" />
          </md-field>
        </div>
      </form>

      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-button class="md-raised" @click="updatingOverage = true" v-if="!updatingOverage">
            Update overage price
          </md-button>
          <md-button class="md-raised md-primary" @click="saveEnterpriseOveragePrice"
            v-if="updatingOverage">
            Save overage price
          </md-button>
          <md-button class="md-raised" @click="updatingOverage = false" v-if="updatingOverage">
            Cancel
          </md-button>
        </div>
      </div>
    </div>
    <snackbar-message-handler :message="snackbarMessage"></snackbar-message-handler>
  </div>
</template>
<script type="ts">
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';

export default {
  components: {
    SnackbarMessageHandler,
  },
  name: 'enterprise-document-overage',
  props: ['enterprise'],
  filters: {
    toCurrency(input) {
      if (!input) return '';

      return `AUD ${(input / 100).toFixed(2)}`;
    },
  },
  methods: {
    saveEnterpriseOveragePrice() {
      let amount = Math.trunc(parseFloat(this.overage.newPrice) * 100);

      if (amount === 0) {
        amount = null;
      }

      this.enterpriseService.updateEnterprise(
        this.enterprise.id,
        {
          owner: {
            stripeOveragePrice: amount,
          },
        },
      ).then(() => {
        this.snackbarMessage = 'Overage price updated.';
        this.updatingOverage = false;
        this.localEnterprise.owner.stripeOveragePrice = amount;
      });
    },
  },
  computed: {
    localEnterprise: {
      get() {
        return this.enterprise;
      },
      set(value) {
        this.$emit('enterpriseChange', value);
      },
    },
  },
  data: () => ({
    updatingOverage: false,
    creatingPrice: false,
    enterpriseService: new EnterpriseService(),
    overage: {
      newPrice: '',
      prices: [],
    },
    snackbarMessage: '',
  }),
  mounted() {
    this.overage.newPrice = this.enterprise.owner.stripeOveragePrice / 100;
  },
};
</script>
